import { ChangeDetectionStrategy, Component } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Component({
  selector: 'hlm-radio-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-slot': 'radio-group-indicator',
  },
  template: `
    <div
      class="group-data-[checked=true]:bg-[var(--surface-brand-accent)] size-2.5 rounded-full bg-transparent"
    ></div>
  `,
})
export class HlmRadioIndicator {
  constructor() {
    classes(
      () =>
        'border-[var(--border-accent)] bg-[var(--surface-theme)] group-data-[checked=true]:border-[var(--surface-brand-accent)] group-has-[:focus-visible]:border-ring group-has-[:focus-visible]:ring-ring group-data-[disabled=true]:cursor-not-allowed group-data-[disabled=true]:opacity-50 group-data-[disabled=true]:bg-[var(--surface-neutral-200)] relative flex aspect-square size-4 shrink-0 items-center justify-center rounded-full border transition-[background-color,border-color,box-shadow] outline-none group-has-[:focus-visible]:ring-[3px]'
    );
  }
}
